// Display labels for the double-bracket knockout stage (winners bracket / losers bracket).
// SPL brands these as "Masters Round" / "Consolation Round"; every other org uses the
// generic "Masters Cup" / "Tour Cup" names. The underlying data keys (mastersCup/tourCup)
// never change - only the label shown to users.

export interface BracketNames {
  primary: string; // winners bracket (mastersCup)
  secondary: string; // losers/consolation bracket (tourCup)
}

export function getBracketNames(orgSlug?: string | null): BracketNames {
  if (orgSlug === "spl") {
    return { primary: "Masters Round", secondary: "Consolation Round" };
  }
  return { primary: "Masters Cup", secondary: "Tour Cup" };
}

// Rewrites a backend-generated label (e.g. "1st - Masters Cup Winner") so it uses the
// org-specific bracket names instead of the generic "Masters Cup" / "Tour Cup" wording.
export function localizeBracketLabel(label: string, orgSlug?: string | null): string {
  const { primary, secondary } = getBracketNames(orgSlug);
  return label.replace(/Masters Cup/g, primary).replace(/Tour Cup/g, secondary);
}
